import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../services/auth.service';

const TIMEOUT_IN_MS = 60 * 60 * 1000; // 1 hora en milisegundos

export const useSessionTimeout = () => {
  const navigate = useNavigate();

  const handleInactivity = useCallback(() => {
    console.log('Sesión expirada por inactividad');
    logout();
    navigate('/login', { replace: true });
  }, [navigate]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const resetTimer = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(handleInactivity, TIMEOUT_IN_MS);
    };

    // Lista de eventos que consideramos como "actividad"
    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click',
      'keydown'
    ];

    // Iniciar el temporizador
    resetTimer();

    // Agregar event listeners para resetear el temporizador
    events.forEach(event => {
      document.addEventListener(event, resetTimer);
    });

    // Cleanup
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      events.forEach(event => {
        document.removeEventListener(event, resetTimer);
      });
    };
  }, [handleInactivity]);
};
